import React from 'react'
import Head from 'next/head'
import Nav from './nav'
import {useRouter} from 'next/router';
import {NextSeo} from 'next-seo';
import theme from "../theme"
import {OpenGraph} from "next-seo/lib/types";

interface HeaderProps {
    title: string
    description: string
    noindex?: boolean
    nofollow?: boolean
    openGraph?: OpenGraph
}

function Header({title, description, noindex, nofollow, openGraph}: HeaderProps)  {
    const router = useRouter();
    const hostUrl = process.env.NEXT_PUBLIC_VERCEL_URL;
    const canonicalUrl = hostUrl + router.asPath;
    const defaultOpenGraph: OpenGraph = {
        type: 'website',
        locale: router.locale,
        url: canonicalUrl,
        site_name: 'MoLabs',
    };

    return (
        <React.Fragment>
            <Head>
                <link href="https://fonts.googleapis.com/css?family=Poppins:600|Raleway:500&display=swap" rel="stylesheet"/>
                {router.locales.map(lang => (
                    <link key={lang} href={hostUrl + (lang === router.defaultLocale ? router.asPath : '/' + lang + router.asPath)} hrefLang={lang} rel={"alternative"}/>
                ))}
                <link rel="manifest" href="/manifest.json" />
                <link rel="shortcut icon" href="/favicon.ico" />
                <link rel="apple-touch-icon" sizes="180x180" href="/images/logo-orange_180x180.png" />
            </Head>
            <Nav/>
            <NextSeo
                title={title}
                titleTemplate={'%s | MoLabs'}
                description={description}
                canonical={canonicalUrl}
                noindex={noindex}
                nofollow={nofollow}
                openGraph={{...defaultOpenGraph, ...openGraph}}
                additionalMetaTags={[{
                    name: 'theme-color',
                    content: theme.palette.primary.main
                }]}
            />
        </React.Fragment>
    );
}

export default Header;
